import OfferMessages from './OfferMessages';

export default OfferMessages;
